export default "/packs/images/mike~d83363e14869f4cafb3f1d385930c70c.png";